module.exports = __webpack_public_path__ + "static/media/twitter-social-media-social-network-logo-svgrepo-com.f6212c3a.svg";